/**
 * Visa Footer Component Styles
 */
visa-footer {
  display: block;
  font-family: var(--visa-font-family, 'Visa Dialect', Arial, sans-serif);
  color: var(--visa-light-text, #ffffff);
}

.vs-footer {
  background-color: #020f27; /* Dark blue background from Figma */
  padding: 48px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
}

@media (max-width: 640px) {
  .vs-footer {
    padding: 24px;
  }
}

.vs-footer-loading {
  padding: 20px;
  text-align: center;
  font-weight: bold;
}

.vs-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.vs-footer-container {
  max-width: 1200px;
}

.vs-thin-footer-container {
  max-width: 1200px;
  text-align: center;
}
.footer-container {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.vs-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.vs-col {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.vs-col-12 {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  flex: 0 0 100%;
  max-width: 100%;
}

.vs-col-auto {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.vs-align-items-center {
  align-items: center !important;
}

.vs-justify-content-end {
  justify-content: flex-end !important;
}

.vs-justify-content-between {
  justify-content: space-between !important;
}

.vs-lowernav {
  width: 100%;
}

.vs-text {
  margin: 0;
}

.vs-meta {
  font-size: var(--visa-font-size-small, 12px);
  color: var(--visa-light-text, #ffffff);
}

.vs-copyright {
  margin-top: 24px;
}

/* Navigation Container */
.navigation-container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-bottom: 48px */
  /* padding-left: 2rem;
  padding-right: 2rem; */
  box-sizing: border-box;
}

/* Language Selector Container */
.language-selector-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 48px;
  @media (min-width: 480px) {
    margin-bottom: 0;
  }
}

/* Navigation Sections */
.navigation-sections {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  margin-bottom: 48px;
  max-width: 1200px;
  margin-left: 0;
  margin-right: auto;
  justify-content: start;
  width: 100%;
  @media (min-width: 480px) {
    margin-bottom: 80px;
  }
}

.nav-section .subhead {
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
  line-height: 1.4;
  color: #d9dffb;
  @media (min-width: 480px) {
    margin-bottom: 12px;
  }
}

.nav-section .nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-section .nav-item {
  display: flex;
  gap: 12px;
  align-items: center;
  min-height: 32px;
  border-radius: 16px;
  width: 184px;
}

@media (max-width: 768px) {
  .nav-section .nav-item {
    width: auto;
  }
}

.nav-section .nav-item .visa-icon-opt-in-out {
  display: inline;
  padding-left: 6px;
  position: relative;
  top: 2px;
}

.nav-section .nav-item a {
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5em;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.1s ease;
}

.nav-section .nav-item .arrow-icon {
  transition:
    margin-right 0.1s ease,
    color 0.1s ease;
  margin-left: auto;
  & .rotate-up-right {
    transform: rotate(-45deg);
    transform-origin: center; /* make sure it rotates around its center */
    transition:
      transform 0.3s ease,
      color 0.3s ease;
  }
}

.nav-section .nav-item:hover {
  a {
    color: #8f9fe4;
  }
  .arrow-icon {
    margin-right: 8px;
    color: #8f9fe4;
  }
}

.nav-section .nav-item .arrow-icon {
  font-size: 14px;
  color: #ffffff;
}

/* Footer Bottom */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 48px;
  @media (min-width: 480px) {
    margin-bottom: 80px;
  }
}

.social-icons-container {
  display: flex;
  align-items: center;
}

.copyright-container {
  display: flex;
  align-items: center;
}

/* Language Selector */
.language-selector {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px;
  gap: 8px;
}

.language-selector .language-icon {
  width: 24px;
  height: 24px;
}

.language-selector .country {
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.language-selector .separator {
  color: rgba(255, 255, 255, 0.5);
}

.language-selector .language {
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.language-selector .chevron-down {
  font-size: 10px;
  transition: transform 0.3s ease;
  color: #ffffff;
}

.language-selector .chevron-down.open {
  transform: rotate(180deg);
}

.language-selector .country-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #2a2f45;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 280px;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.language-selector .country-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
}

.language-selector .country-dropdown li {
  display: flex;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.language-selector .country-dropdown li:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.language-selector .country-dropdown li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.language-selector .country-dropdown .country-code {
  font-weight: 500;
  width: 40px;
}

.language-selector .country-dropdown .country-name {
  flex-grow: 1;
  margin-right: 12px;
}

.language-selector .country-dropdown .country-language {
  color: #d9dffc;
  font-size: 12px;
}

/* Social Icons */
.social-icons {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  list-style: none; /* NEW */
  padding: 0; /* NEW */
  margin: 0; /* NEW */
}

.social-icon-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-decoration: none;
  transition: opacity 0.2s;
}

.social-icon:hover {
  color: #8f9fe4;
}

.social-icon .icon {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

/* Social Dropdown */
.vs-footer-social-dropdown {
  position: relative;
  display: inline-block;
}

.vs-footer-social-button {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-size: 14px;
  padding: 0;
}

/* .vs-footer-social-icon {
  margin-right: 8px;
} */

.vs-footer-social-dropdown-arrow {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.vs-footer-social-dropdown-arrow.open {
  transform: rotate(180deg);
}

.vs-footer-social-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #2a2f45;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 200px;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.vs-footer-social-dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vs-footer-social-dropdown-item {
  padding: 8px 16px;
}

.vs-footer-social-dropdown-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  display: block;
  transition: opacity 0.2s;
}

.vs-footer-social-dropdown-link:hover {
  opacity: 0.8;
}

/* Visa Logo */
.visa-logo-container {
  width: 100%;
  display: flex;
  margin: 0;
  justify-content: center;
}

.visa-logo-container svg {
  width: 90%;
  height: auto;
}

@media (max-width: 640px) {
  .language-selector-container {
    justify-content: flex-start;
    padding: 0;
    margin-bottom: 48px;
  }

  /* Remove padding for language selector in mobile view */
  .language-selector {
    padding: 0;
  }
}

/* Media Queries */
@media (min-width: 576px) {
  .vs-container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .vs-container {
    max-width: 720px;
  }

  .vs-col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 992px) {
  .vs-container {
    max-width: 960px;
  }

  .vs-col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .vs-col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .vs-col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  .vs-copyright {
    margin-top: 0;
  }
}

.copyright {
  font-family: 'Visa Dialect', Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: #d9dffb;
  text-align: right;
}

@media (min-width: 1200px) {
  .vs-container {
    max-width: 1140px;
  }
}

@media (max-width: 1024px) {
  .navigation-sections {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .navigation-sections {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .copyright {
    text-align: left;
    width: 100%;
  }

  .vs-copyright {
    text-align: left;
    width: 100%;
  }

  .language-selector-container {
    justify-content: flex-start;
    padding: 0;
  }

  /* Remove padding for language selector in mobile view */
  .language-selector {
    padding: 0;
  }

  .social-icons-container {
    justify-content: flex-start;
  }

  .navigation-container,
  .footer-bottom,
  .social-icons-container,
  .copyright-container {
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
  }
}

/* Thin Footer Specific Styles */
.vs-thin-footer-container .vs-copyright {
  margin-top: 16px;
  text-align: center;
}
.vs-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* BOTTOM PANEL */

.visa-footer-bottom-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff; /* White background */
  padding: 2rem;
  z-index: 9999; /* Increased z-index */
  width: 100%;
  box-sizing: border-box;
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.3s ease-in-out;
  visibility: hidden;
  pointer-events: none;
}

.visa-footer-bottom-panel.show {
  transform: scaleY(1);
  visibility: visible;
  pointer-events: auto;
}
.visa-footer-panel-left {
  flex: 1;
}

@media (max-width: 480px) {
  .visa-footer-panel-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.visa-footer-panel-right {
  flex: 1;
  position: relative;

  /* Scroll control */
  max-height: 616px;
  overflow-y: auto;

  /* Hide scrollbar for WebKit browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

/* Hide scrollbar for Chrome, Safari and Edge */
.visa-footer-panel-right::-webkit-scrollbar {
  display: none;
}

.visa-footer-selected-language {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.visa-footer-selected-language-info {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.01em;
  color: #656565;
}
.visa-footer-selected-language-info.label {
  font-size: 12px;
}
.visa-footer-selected-language-info.language {
  color: #767676;
  min-height: 40px;
  font-weight: 400;
  cursor: pointer;
}

.visa-footer-selected-language-info.language:hover {
  transition: all 0.2s ease;
  margin-left: 4px;
  color: #555555; /* Slightly lighter on hover */
  text-decoration: none;
}

.visa-footer-panel-content {
  display: flex;
  position: relative;
}

.visa-footer-panel-divider {
  background-color: #e0e0e0;
}

/* Desktop: Vertical line */
@media (min-width: 481px) {
  .visa-footer-panel-divider {
    width: 1px;
    height: auto;
    margin: 0 1rem;
  }
}

/* Mobile: Horizontal line */
@media (max-width: 480px) {
  .visa-footer-panel-content {
    flex-direction: column;
  }

  .visa-footer-panel-divider {
    width: 100%;
    height: 1px;
    margin: 1rem 0;
  }
}

.visa-footer-panel-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
}

@media (max-width: 480px) {
  .visa-footer-panel-footer {
    padding-top: 0;
    justify-content: start;
  }
}

.visa-footer-panel-name {
  font-size: 32px;
  font-weight: 400;
  line-height: 1.25;
  color: #1a1a1a; /* Dark text */
}

@media (max-width: 480px) {
  .visa-footer-panel-name {
    margin-top: 0;
  }
}

.visa-footer-card-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.visa-footer-card-item {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.01em;
  color: #1a1a1a; /* Dark text */
  padding: 0.5rem 0;
  cursor: pointer;
}

.visa-footer-card-item:hover {
  transition: all 0.2s ease;
  margin-left: 4px;
  color: #555555; /* Slightly lighter on hover */
  text-decoration: none;
}

.visa-footer-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
}

.visa-footer-close-icon {
  position: relative;
  width: 14px;
  height: 14px;
}

.visa-footer-close-icon:before,
.visa-footer-close-icon:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1a1a1a; /* Dark close icon */
}

.visa-footer-close-icon:before {
  transform: rotate(45deg);
}

.visa-footer-close-icon:after {
  transform: rotate(-45deg);
}

.visa-footer-see-all-link {
  display: flex;
  align-items: center;
  color: #1a1a1a; /* Dark link */
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  gap: 0.5rem;
  transition:
    gap 0.2s,
    color 0.2s;
}

.visa-footer-see-all-link:hover {
  color: #1434cb; /* Blue on hover */
  text-decoration: none;
  gap: 1rem;
}

.visa-footer-see-all-link:hover .visa-footer-arrow-right {
  color: #1434cb;
}

.visa-footer-card-item {
  transition: opacity 0.3s ease;
}

.visa-footer-card-item.dim-1 {
  opacity: 0.5;
}

.visa-footer-card-item.dim-2 {
  opacity: 0.2;
}
/* ACCESSIBILITY: FOCUS INDICATORS */
/* Only visible for keyboard navigation, not mouse clicks */

/* Remove default focus outline for mouse clicks */
.nav-section .nav-item a:focus:not(:focus-visible),
.social-icon:focus:not(:focus-visible),
.vs-footer-social-button:focus:not(:focus-visible),
.vs-footer-social-dropdown-link:focus:not(:focus-visible),
.language-selector:focus:not(:focus-visible),
.visa-footer-card-item:focus:not(:focus-visible),
.visa-footer-close-btn:focus:not(:focus-visible),
.language-selector .country-dropdown li:focus:not(:focus-visible) {
  outline: none;
  background-color: transparent;
  transform: none;
  color: inherit;
}

/* Navigation Links Focus - Keyboard Only */
.nav-section .nav-item a:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Social Icons Focus - Keyboard Only */
.social-icon:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

/* Social Dropdown Button Focus - Keyboard Only */
.vs-footer-social-button:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Social Dropdown Links Focus - Keyboard Only */
.vs-footer-social-dropdown-link:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 1px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Language Selector Focus - Keyboard Only */
.language-selector:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Country Options Focus - Keyboard Only */
.visa-footer-card-item:focus-visible {
  outline: 2px solid #1434cb;
  outline-offset: 2px;
  border-radius: 4px;
  background-color: rgba(20, 52, 203, 0.1);
  color: #1434cb;
}

/* Close Button Focus - Keyboard Only */
.visa-footer-close-btn:focus-visible {
  outline: 2px solid #1434cb;
  outline-offset: 2px;
  border-radius: 4px;
  background-color: rgba(20, 52, 203, 0.1);
}

/* Country Dropdown Items Focus - Keyboard Only */
.language-selector .country-dropdown li:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 1px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.15);
}

/* Enhanced Focus for High Contrast Mode - Keyboard Only */
@media (prefers-contrast: high) {
  .nav-section .nav-item a:focus-visible,
  .social-icon:focus-visible,
  .vs-footer-social-button:focus-visible,
  .vs-footer-social-dropdown-link:focus-visible,
  .language-selector:focus-visible {
    outline: 3px solid #ffffff;
    outline-offset: 3px;
    background-color: rgba(255, 255, 255, 0.2);
  }

  .visa-footer-card-item:focus-visible,
  .visa-footer-close-btn:focus-visible {
    outline: 3px solid #1434cb;
    outline-offset: 3px;
    background-color: rgba(20, 52, 203, 0.2);
  }
}

/* Focus for Reduced Motion Users - Keyboard Only */
@media (prefers-reduced-motion: reduce) {
  .social-icon:focus-visible {
    transform: none;
  }
}

/* Fallback for browsers that don't support :focus-visible */
/* This ensures accessibility while preventing mouse focus */
@supports not selector(:focus-visible) {
  .nav-section .nav-item a:focus,
  .social-icon:focus,
  .vs-footer-social-button:focus,
  .vs-footer-social-dropdown-link:focus,
  .language-selector:focus,
  .visa-footer-card-item:focus,
  .visa-footer-close-btn:focus,
  .language-selector .country-dropdown li:focus {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .visa-footer-card-item:focus,
  .visa-footer-close-btn:focus {
    outline-color: #1434cb;
    background-color: rgba(20, 52, 203, 0.1);
  }
}
